import type OT from '@vonage/client-sdk-video';
import { LiveParticipant, UserInformation, ParticipantVonage } from '@shared/models/live';
import { RoleEnum } from '@shared/enums/user';
import { AUDIO_ONLY_PREFIX } from './audio-device-fact';

export function isAudioOnlyExternalId(externalId: unknown): externalId is string {
  return typeof externalId === 'string' && externalId.startsWith(AUDIO_ONLY_PREFIX);
}

export function buildLiveParticipant(
  connection: OT.Connection,
  metadata: ParticipantVonage,
  userInfo: UserInformation | null | undefined,
  appRights: string[],
): LiveParticipant {
  const isAudioOnly = isAudioOnlyExternalId(metadata.externalId);

  return {
    participant: metadata,
    userInfo: userInfo as UserInformation | undefined,
    uuid: metadata.externalId,
    isMuted: isAudioOnly ? true : userInfo?.role !== RoleEnum.Equipment,
    liveRole: userInfo?.role,
    appRights,
    connectionId: connection.connectionId,
    connection,
    shortName: isAudioOnly ? '' : `${userInfo?.firstName ? userInfo.firstName[0] : ''}${userInfo?.lastName ? userInfo.lastName[0] : ''}`,
    // An audio-only device's display name comes from the presence broadcast, not the connection.
    fullName: isAudioOnly
      ? ''
      : [userInfo?.title !== 'Other' ? userInfo?.title : '', userInfo?.firstName, userInfo?.lastName]
          .map((part) => part?.trim())
          .filter(Boolean)
          .join(' '),
    isAudioOnly,
    audioDeviceId: isAudioOnly ? metadata.externalId.slice(AUDIO_ONLY_PREFIX.length) : undefined,
  };
}
